import { lotsServices } from "../../../../../api/lots";
import { sumSpMovingQty } from "../../../../../api/storePlaces";
import type { FinishedGoodsReceiptContent } from "../../../../../api/finishedGoodsReceipts";

/** Результат поиска строки ВЗН УП по скану этикетки изделия. */
export type StockFinishedGoodsReceiptContentScanResult =
    | { type: "notFound" }
    | { type: "alreadyPlaced"; contentCode: number }
    | { type: "single"; contentCode: number }
    | { type: "ambiguous"; contentCodes: number[] };

/**
 * Ищет строку ВЗН УП по отсканированному `SoNum` партии. \
 * Ожидаем ровно одну партию по `SoNum`, затем строку с `ArrivalSdbCode === lot.LotCode`.
 * @param barcode отсканированное значение (`SoNum`)
 * @param contents текущие строки ВЗН УП (уже без `LotCode = 0`)
 */
export async function resolveStockFinishedGoodsReceiptContentScan(
    barcode: string,
    contents: FinishedGoodsReceiptContent[],
): Promise<StockFinishedGoodsReceiptContentScanResult> {
    const soNum = barcode.trim();
    if (soNum === "") {
        return { type: "notFound" };
    }

    const lots = await lotsServices.load({ flt: { SoNum: soNum } });
    if (lots.length !== 1 || lots[0].LotCode === 0) {
        return { type: "notFound" };
    }

    const lotCode = lots[0].LotCode;

    const matches = contents.filter((content) => content.ArrivalSdbCode === lotCode);

    if (matches.length === 0) {
        return { type: "notFound" };
    }

    if (matches.length > 1) {
        return { type: "ambiguous", contentCodes: matches.map((content) => content.Code) };
    }

    const content = matches[0];
    const placedQty = sumSpMovingQty(content.SpMovings);
    if (content.ArrivalQty > 0 && placedQty >= content.ArrivalQty) {
        return { type: "alreadyPlaced", contentCode: content.Code };
    }

    return { type: "single", contentCode: content.Code };
}
